import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar, MobileSidebarDrawer } from '@/components/layout/Sidebar';
import { Topbar } from '@/components/layout/Topbar';
import { Footer } from '@/components/layout/Footer';
import { AiAssistantPanel } from '@/features/ai/components/AiAssistantPanel';
import { IdleDetectionMonitor } from '@/features/time-tracking/components/IdleDetectionMonitor';
import { OrgCustomCssInjector } from '@/features/settings/components/OrgCustomCssInjector';

const COLLAPSE_STORAGE_KEY = 'pp_sidebar_collapsed';

export function AppLayout() {
  const [isCollapsed, setIsCollapsed] = useState(() => localStorage.getItem(COLLAPSE_STORAGE_KEY) === '1');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  function toggleCollapsed() {
    setIsCollapsed((current) => {
      const next = !current;
      localStorage.setItem(COLLAPSE_STORAGE_KEY, next ? '1' : '0');
      return next;
    });
  }

  return (
    <div className="flex min-h-screen bg-gray-50 dark:bg-gray-950">
      <OrgCustomCssInjector />
      <Sidebar collapsed={isCollapsed} onToggleCollapsed={toggleCollapsed} />
      <MobileSidebarDrawer isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} />

      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar onOpenMobileMenu={() => setIsMobileMenuOpen(true)} />
        <main className="flex-1 p-4 sm:p-6">
          <Outlet />
        </main>
        <Footer />
      </div>

      <AiAssistantPanel />
      <IdleDetectionMonitor />
    </div>
  );
}
